module.exports = "../../app/cells/pages/question/plans_highlights_cell.rb";